import React from "react";
import { Link } from "react-router-dom";
import { Columns2 } from "lucide-react";

export const CompareCourses = ({ instrument }) => {
  const [a, b] = instrument.courses;
  if (!a || !b) return null;
  return (
    <section className="mt-14" data-testid="compare-courses">
      <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-primary"><Columns2 size={14} /> Compare courses</p>
      <h2 className="mt-2 font-serif text-3xl">Which level suits you?</h2>
      <p className="mt-2 text-sm text-muted-foreground">Both syllabuses side by side. If most of the left column feels familiar, start with the right.</p>
      <div className="mt-6 grid gap-4 md:grid-cols-2">
        {[a, b].map((c) => (
          <div key={c.id} className="rounded-2xl border border-border bg-card p-5" data-testid={`compare-col-${c.id}`}>
            <p className="font-mono text-[11px] uppercase tracking-widest text-primary">{c.from} → {c.to}</p>
            <Link to={`/courses/${instrument.id}/${c.id}`} className="mt-1 block font-serif text-xl hover:text-primary" data-testid={`compare-open-${c.id}`}>{c.title}</Link>
            <ol className="mt-4 space-y-2">
              {c.lessons.map((l, i) => (
                <li key={l.id} className="flex gap-3 text-sm">
                  <span className="w-5 shrink-0 font-mono text-primary">{i + 1}</span>
                  <span><span className="text-foreground">{l.title}</span><span className="block text-xs text-muted-foreground">{l.topic}</span></span>
                </li>
              ))}
            </ol>
          </div>
        ))}
      </div>
    </section>
  );
};
